import { InputNumber as AntInputNumber } from 'antd'
import type { ComponentProps } from 'react'
import { SIZE_MAP } from '../types'
import type { Size } from '../types'

type AntInputNumberProps = ComponentProps<typeof AntInputNumber>

export interface AppInputNumberProps extends Omit<AntInputNumberProps, 'size' | 'onChange'> {
  size?: Size
  onChange?: (value: any) => void
}

export const AppInputNumber = ({ size = 'md', ...rest }: AppInputNumberProps) => (
  <AntInputNumber size={SIZE_MAP[size]} {...(rest as AntInputNumberProps)} />
)
